import React from "react";
import { Separator } from "./ui/separator";
import { Linkedin, Facebook, Instagram, Youtube } from "lucide-react";
import { mockData } from "../mock";

const iconMap = {
  Linkedin,
  Facebook,
  Instagram,
  Youtube
};

const Footer = () => {
  const { footer } = mockData;

  return (
    <footer className="bg-gradient-to-b from-slate-900 to-slate-800 text-white">
      <div className="container mx-auto px-6 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {footer.columns.map((column, index) => (
            <div key={index}>
              <h3 className="text-lg font-bold mb-6 text-amber-400">
                {column.title}
              </h3>
              <ul className="space-y-3">
                {column.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a 
                      href={link.url} 
                      className="text-gray-300 hover:text-white hover:text-amber-400 transition-colors duration-200"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <Separator className="bg-gray-700 mb-8" />

        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
          {/* Logo Only - Clean Integration */}
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_premier-b2b-site/artifacts/4ivcj81e_Logo.svg"
              alt="CNESS Logo"
              className="h-10 w-auto opacity-90 hover:opacity-100 transition-opacity duration-300"
              style={{filter: 'brightness(0) invert(1)'}}
            />
          </div>

          {/* Social Media Icons */}
          <div className="flex items-center space-x-6">
            {footer.socialMedia.map((social, index) => {
              const IconComponent = iconMap[social.icon];
              return (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-gray-700 hover:bg-amber-500 flex items-center justify-center transition-all duration-300 hover:scale-110 group"
                  aria-label={social.platform}
                >
                  <IconComponent className="h-5 w-5 text-gray-300 group-hover:text-white transition-colors duration-300" />
                </a>
              );
            })}
          </div>
        </div>

        <Separator className="bg-gray-700 my-8" />

        {/* Copyright */}
        <div className="text-center">
          <p className="text-gray-400 text-sm">
            {footer.copyright}
          </p>
          <p className="text-gray-500 text-xs mt-2">
            Building the future of conscious business, one certification at a time.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;